

























import { Component, Prop, Vue } from 'vue-property-decorator'

import { Order, OrderStatus, OrderType } from '@/models'

import { VuesaxColors } from '@/shims-vuesax'

@Component
export default class OrderStatusChip extends Vue {
  @Prop({ type: Object, required: true })
  readonly order!: Order

  OrderStatusColors: { [key in OrderStatus]: VuesaxColors } = {
    [OrderStatus.OPEN]: 'warning',
    [OrderStatus.AUTHORIZED]: 'dark',
    [OrderStatus.STARTED]: 'primary',
    [OrderStatus.COMPLETED]: 'success',
    [OrderStatus.CANCELED]: 'danger'
  }

  OrderStatusTexts: { [key in OrderStatus]: string } = {
    [OrderStatus.OPEN]: 'Aberto',
    [OrderStatus.AUTHORIZED]: 'Aguardando',
    [OrderStatus.STARTED]: 'Preparando',
    [OrderStatus.COMPLETED]: 'Completado',
    [OrderStatus.CANCELED]: 'Cancelado'
  }

  OrderTypeIcons: { [key in OrderType]: string } = {
    [OrderType.IN_LOCO]: '',
    [OrderType.TAKEOUT_NOW]: 'local_mall',
    [OrderType.TAKEOUT_LATER]: 'local_mall',
    [OrderType.DELIVERY]: 'local_shipping'
  }

  get inLoco () {
    return this.order.type === OrderType.IN_LOCO
  }

  get statusColor () {
    return this.OrderStatusColors[this.order.status]
  }

  get statusText () {
    return this.OrderStatusTexts[this.order.status]
  }
}
